<template>
  <ten-picker
    v-bind="$attrs"
    :type="mode"
    :value="value"
    :disabled-date="disabledDate"
    :min-date="_minDate"
    :max-date="_maxDate"
    :is-range="isRange"
    v-on="$listeners"
  >
    <template #default="{ time, onChangeHandler, getRelatedInput, format }">
      <ten-date-time
        v-if="mode === 'datetime'"
        :value="time"
        :format="format"
        :is-range="isRange"
        :get-related-input="getRelatedInput"
        :first-day-of-week="firstDayOfWeek"
        :disabled-date="disabledDate"
        :disabled-hour="disabledHour"
        :disabled-min="disabledMin"
        :disabled-sec="disabledSec"
        :min-date="_minDate"
        :max-date="_maxDate"
        @change="onChangeHandler"
      />
      <component
        v-else
        :is="isRange ? 'TenDateRange' : 'TenDate'"
        :value="time"
        :mode="mode"
        :first-day-of-week="firstDayOfWeek"
        :disabled-date="disabledDate"
        :min-date="_minDate"
        :max-date="_maxDate"
        @change="onChangeHandler"
      />
    </template>

    <template #suffxIcon>
      <!-- @slot @ignore -->
      <slot name="suffixIcon" />
    </template>

    <template #clearIcon>
      <!-- @slot @ignore -->
      <slot name="clearIcon" />
    </template>
  </ten-picker>
</template>

<script>
import TenPicker from './picker';
import TenDate from './panel/date';
import TenDateRange from './panel/date-range';
import TenDateTime from './panel/date-time';
import { isString, isDate } from '../scripts/utils/helper';
import { setDateTime } from './util';

const name = 'ten-date-picker';

export default {
  name,
  components: {
    TenPicker,
    TenDate,
    TenDateRange,
    TenDateTime,
  },
  provide() {
    return {
      wrapper: this,
    };
  },
  inheritAttrs: false,
  model: {
    value: 'value',
    event: 'change',
  },
  props: {
    /**
     * @ignore
     */
    value: { type: [Date, String, Array] },
    /**
     * @ignore
     */
    isRange: Boolean,
    /**
     * 最小可选日期，只取日期部分的值
     * Date类型，或者能被new Date()解析的字符串
     */
    minDate: { type: [String, Date] },
    /**
     * 最大可选日期，只取日期部分的值
     * Date类型，或者能被new Date()解析的字符串
     */
    maxDate: { type: [String, Date] },
    /**
     * 禁用日期，函数参数为日期，当返回false时，该日期被禁选
     */
    disabledDate: { type: Function, default: () => false },
    /**
     * 周起始日， 与Date getDay方法对应
     */
    firstDayOfWeek: { type: Number, default: 0, validator(v) {
      return [0, 1, 2, 3, 4, 5, 6].indexOf(v) > -1;
    } },
    /**
     * 选择模式
     *
     * @member date | datetime | year | month
     */
    mode: { type: String, default: 'date', validator(v) {
      return ['date', 'datetime', 'year', 'month'].indexOf(v) > -1;
    } },
    /**
     * mode = 'datetime' 时有效
     * 禁用小时，函数参数为 hour，当返回false时，该小时被禁选
     */
    disabledHour: { type: Function, default: () => false },
    /**
     * mode = 'datetime' 时有效
     * 禁用分钟，函数参数为 (hour, minute)，当返回false时，该分钟被禁选
     */
    disabledMin: { type: Function, default: () => false },
    /**
     * mode = 'datetime' 时有效
     * 禁用秒，函数参数为 (hour, minute, second)，当返回false时，该秒被禁选
     */
    disabledSec: { type: Function, default: () => false },
    /**
     * mode = 'datetime'
     * 最小可选时间，只取时间部分的值
     */
    // minTime: Date
  },
  computed: {
    _minDate() {
      return this.getValidDate(this.minDate);
    },
    _maxDate() {
      return this.getValidDate(this.maxDate);
    },
  },
  methods: {
    getValidDate(value) {
      if (isString(value)) {
        value = new Date(value);
      }

      if (!isDate(value)) return null;
      return this.mode === 'datetime' ? value : setDateTime(value, 0, 0, 0);
    },
  },
};
</script>
